import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { MenuItem, Select, SelectChangeEvent } from '@mui/material'

import Dialog from '@/components/UI/Dialog/Dialog'
import './index.scss'
import { updateSelectedLanguage } from '@/store/common/actions'
import i18n from '../UI/Internationalisation/i18n'
import { useTranslation } from 'react-i18next'
import {
  LANGUAGE_OPTIONS,
  getDefaultLanguageCode,
} from '@/config/languages.constants'

const ChangeLanguage = (props: any) => {
  const dispatch = useDispatch()
  const { t } = useTranslation('translation')
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    getDefaultLanguageCode(),
  )

  const initialLanguage =
    localStorage.getItem('selectedLanguageCode') || getDefaultLanguageCode()

  useEffect(() => {
    setSelectedLanguage(initialLanguage)
  }, [props.show])

  const saveLanguageSetting = () => {
    dispatch(updateSelectedLanguage(selectedLanguage))
    i18n.changeLanguage(selectedLanguage)
    props.onHide()
  }

  return (
    <Dialog
      open={props.show}
      onClose={props.onHide}
      title={t('Change Language')}
      showCloseButton
      sx={{ width: '400px' }}
      footerActions={[
        {
          title: t('Close'),
          variant: 'outlined',
          onClick: props.onHide,
        },
        {
          title: t('Save Changes'),
          variant: 'contained',
          color: 'primary',
          onClick: saveLanguageSetting,
          disabled: selectedLanguage === initialLanguage,
        },
      ]}
    >
      <div className="tw-mb-4">
        <h3 className="tw-mb-2 tw-text-base tw-font-semibold">
          {t('View Page in')}
        </h3>
        <Select
          fullWidth
          value={selectedLanguage}
          onChange={(e: SelectChangeEvent) => {
            setSelectedLanguage(e.target.value)
          }}
        >
          {LANGUAGE_OPTIONS.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </div>
    </Dialog>
  )
}

export default ChangeLanguage
